export const DATE_VALUE_TYPE = {
  NONE: 0,
  TODAY: 1,
  TODAY_PLUS: 2,
  TODAY_MINUS: 3,
  CUSTOM: 4,
};
